
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import state from './state'
import mutations from './mutations'
//modules
import remarkModule from "./modules/remark";

Vue.use(Vuex)

export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations,
    modules : {
        //备注
        remark : remarkModule,
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js